(function ($) {
  $(document).ready(function () {
    var navTargets;

    masonryImageVideo();
    imageDownloadPopup();
    videoViewPopup();

    
    
    //Mello Sticky Header
    //window.onscroll = function() {stickyNav()};
    //var headerNav = document.getElementById("shopify-section-header");
    
    //function stickyNav() {
      //if (window.pageYOffset > 0) {
        //headerNav.classList.add("sticky");
      //} else {
        //headerNav.classList.remove("sticky");
      //}
    //}
    

    

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    // Stolen from underscore.
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate)
            func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
          func.apply(context, args);
      };
    }
    // Our debounced mechanism for repositoning the notch on resize.
    var positionNotchOnResize = debounce(function () {
      var activeNav = $('.main-nav-link.active');
      if (activeNav.length > 0) {
        positionNotch(activeNav);
      }
    }, 550);
    $(window).resize(positionNotchOnResize);


    /*
         * Account Forms
         */
    $(document).on('click', ".jq-form-link", function(){
      var formId = $(this).data('form');
      $(".jq-form").hide();
      $("#" + formId).show();
      $("html,body").scrollTop(0);
    });




    $(document).on('submit', "#login-form-modal, #registration-form, #forgot-pass-form-modal", function(){
      var _this = $(this);
      var url = checkSecureUrl(_this.attr("action"));
      var msgID = "";

      if(_this.find(".validation-failed").length > 0){
        return false;
      }else{
        return true;
      }




      switch(_this.attr("id")){
        case "login-form-modal":
          msgID = "#status-msg-login";
          break;
        case "registration-form":
          msgID = "#status-msg-register";
          break;
        case "forgot-pass-form-modal":
          msgID = "#status-msg-forgot";
          break;
      }



      $(msgID).html("");
      $.ajax(url, {"method":"post",
                   "type":"post",
                   "dataType":"json",
                   beforeSend:function(){
                     $("#jq-ajax-loader").show().css({position: "fixed",
                                                      height: "100vh",
                                                      "z-index": "500"});
                   },
                   data:_this.serialize(), success:function(response){
                     if(response.status ==  "error"){
                       $(msgID).addClass("error").html(response.data);
                       $("#jq-ajax-loader").attr("style", "");
                     }else if(response.status ==  "success"){
                       //closeMenu();
                       $("#jq-ajax-loader").show().css({position: "fixed",
                                                        height: "100vh",
                                                        "z-index": "500"});
                       // location.reload();
                       window.location.href = accountFormUrl;
                     }else if(response.status ==  "stay-success"){
                       $("#jq-ajax-loader").attr("style", "");
                       $(msgID).addClass("error").html(response.data);
                     }


                   }});
      return false;   
    });


    $(document).delegate("#registration-form #password", "change", function(){
      $("#registration-form #confirmation").val($(this).val());
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
      $('body').addClass("touch mob-width");
    }else{
      $('body').addClass("desktop");
    }

    showHeaderAnnouncement();
    
    //Owl Carousel Slider
    $("#owl-home-slider").owlCarousel({ 
        slideSpeed: 300,
        loop: true,
        dots: false,
        paginationSpeed : 400,
        nav: true,
        autoplay:true,
        items : 1, 
        navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 2px;stroke: #fff;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>','<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 2px;stroke: #fff;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],        
        onInitialize: function (event) {
        if ($('.owl-carousel .item').length <= 1) {
           this.settings.loop = false;
        }
      }
    });
    
    
     $('.filter-pursuit').click(function(e){
    $( ".other-filters" ).toggle( "slow", function() {
        // Animation complete.
      });
        // Cancel the default action
        e.preventDefault();
    });
    
     $('.other-filters .apply-btn').click(function(e) {
          var params = '';
          $("input:checkbox[name=pursuit]:checked").each(function () {
              params += $(this).val() + '+';
           
          });
       
          var lastChar = params[params.length -1];
          if(lastChar == '+'){
                params = params.slice(0,-1);

          }    
       
          var url = window.location.href;  
          if (url.indexOf('tagged') > -1){
                var pieces = url.split("/tagged/");
        url = pieces[0];
                if (params != ''){
                     url += '/tagged/'+ params;
                  }else{
                     url += '';
                  }
          }else{
            if (params != ''){
               url += '/tagged/'+ params;
            }else{
               url += '';
            }
          }
          //alert(url);
          window.location.href = url;
          // Cancel the default action
          e.preventDefault();
      
      });
    
      $('.other-filters .reset-btn').click(function(e)
      {
          var url = window.location.href;  
          if (url.indexOf('tagged') > -1){
                var pieces = url.split("/tagged/");
        url = pieces[0];
                
          }
          window.location.href = url;
          e.preventDefault();
      
      });
    
      checkdefaultCheckboxes();
      

  });//Doc ready ends here
  
   function checkdefaultCheckboxes(){
     if($('.other-filters').length){
          var url = window.location.href;  
          if (url.indexOf('tagged') > -1){
                $( ".other-filters" ).show();
                var pieces = url.split("/tagged/");
        url = pieces[1];     

                var filterArray = url.split('+');
                //console.log(array);
                $.each(filterArray, function(i, val){
                  $("input:checkbox[value='" + val + "']").prop('checked', true);

                });                        
          }     
     } 
    
  }

  function masonryImageVideo(){
    if($('.grid').length){
      var $grid = $('.grid').masonry({
        // options
        columnWidth:".grid-item",
        itemSelector:".grid-item",
        percentPosition:true
      });

      $('.tag-list').find('li').click(function(){
        var clicked_tag = $(this).text();
        if(clicked_tag == 'Show All'){
          $grid.isotope({ filter: '*' });
        }else{
          $grid.isotope({ filter: '.'+clicked_tag });
        }
      });
    }
  }

  function imageDownloadPopup(){
    $('.dealer-image-video').find('.product-image').each(function(key, value){
      $(value).on('click', function(e){
        e.preventDefault();
        $('.file-download-popup').hide();
        $(this).find('.file-download-popup').fadeIn(300);
      });
    });
    $('.file-download-popup').on('click', function(e){
      e.stopPropagation();
    });

    $('.file-download-popup').find('.cancel').on('click', function(e){
      $('.file-download-popup').hide();
    });

    $('.file-download-popup').find('label').on('click', function(e){
      e.stopPropagation();
      $(this).parent().find('input').click();
    });

    $('.file-download-popup').find('input').on('click', function(e){
      e.stopPropagation();
      var fileName = $(this).data('filename');
      var file = $(this).val();
      $(this).parents('.file-download-content').find('.btn-download').prop('href', file).prop('download', fileName);
    });
  }

  function videoViewPopup(){
    $('.dealer-image-video').find('.video-popup').on('click', function(e){
      var video = $(this).data('video');

      $.magnificPopup.open({
        items: {
          src: video
        },
        type: 'iframe'
      }); 
    });
  }

  function mySetCookie(c_name,value,expiredays){
    var exdate=new Date();
    exdate.setDate(exdate.getDate()+expiredays);
    document.cookie=c_name+ "=" +escape(value) + ((expiredays==null) ? "" : ";expires="+exdate.toGMTString());
  }

  function myGetCookie(c_name){
    if (document.cookie.length>0)
    {
      c_start=document.cookie.indexOf(c_name + "=");
      if (c_start!=-1)
      {
        c_start=c_start + c_name.length+1;
        c_end=document.cookie.indexOf(";",c_start);
        if (c_end==-1) c_end=document.cookie.length;
        return unescape(document.cookie.substring(c_start,c_end));
      }
    }
    return "";
  }
  
  function fixFeatureImage() {
    if ($('#PageContainer').hasClass('home-content')) {
      $('.home-container-bg').css({'margin-top':($("#shopify-section-header").height()+'px')});
    } else {
        $('.main-content').css({'margin-top':($("#shopify-section-header").height()+$(".right-bar").height())});
        //$('#PageContainer').height($('#shopify-section-header').height());
    }
  }

  function showHeaderAnnouncement() {
    if($('#yeti-site-banner').length > 0){
      var announcement_closed = myGetCookie("closed_announcement");
      if (announcement_closed == null || announcement_closed == ""){
        $('#yeti-site-banner').addClass('visible');
      }else{
        $('#yeti-site-banner').addClass('closed');
        $('.nav-bar').css('top', $('.header-container').height());
        fixFeatureImage();
      }
      $('#yeti-site-banner').find('.close').click(function(e){
        e.preventDefault();
        $('#yeti-site-banner').addClass("closed");
        mySetCookie("closed_announcement", "true", 2); // 365 days = 1 year
        fixFeatureImage();
      });
    }
  }

  /* Thanks to CSS Tricks for pointing out this bit of jQuery
https://css-tricks.com/equal-height-blocks-in-rows/
It's been modified into a function called at page load and then each time the page is resized. One large modification was to remove the set height before each new calculation. */

  equalheight = function(container){
    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $(container).each(function() {

      $el = $(this);
      $($el).height('auto')
      topPostion = $el.position().top;

      if (currentRowStart != topPostion) {
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPostion;
        currentTallest = $el.outerHeight(true);
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.outerHeight(true)) ? ($el.outerHeight(true)) : (currentTallest);
      }
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  }

  function allEqualHeight(container, element){
    $(container).each(function(){  
      // Cache the highest
      var highestBox = 0;
      // Select and loop the elements you want to equalise
      $(element, this).each(function(){
        // If this box is higher than the cached highest then store it
        if($(this).outerHeight() > highestBox) {
          highestBox = $(this).outerHeight(); 
        }
      });  
      // Set the height of all those children to whichever was highest 
      $(element,this).height(highestBox);
    }); 
  }


  $(window).on('load resize', function() {
    //var loop = setInterval(equalheight('.products-grid li .product-image-block'), 300);
    var loop2 = setInterval(equalheight('.yeti-my-account .info-box'), 500);

    var loop3 = setInterval(allEqualHeight('.container', '.equal-height-box'), 500);
    var loop4 = setInterval(equalheight('.template-blog .slot-grid .module'), 300);

    // some time later clear the interval
    //clearInterval(loop);
    clearInterval(loop2);
    clearInterval(loop3);
    clearInterval(loop4);
    
  });
  
  $(window).on("load", function () {
    if ($('#PageContainer').hasClass('home-content')) {
      //$('.home-container-bg').owlCarousel({items: 1, nav: false, dots: true, loop: true, autoplay: true, navRewind: false, navText: ["",""]});
      $('.home-container-bg').fadeTo( "slow", 1 );
      $('#new-arrivals .items').owlCarousel({
        	items: 4,
        	nav: false,
        	dots: true,
        	loop: true,
        	autoplay: true,
        	margin: 70,
        	navRewind: false,
        	navText: ["",""],
        	responsive:{
                0:{
                    items:1,
                },
                600:{
                    items:3,
                },
                1000:{
                    items:5,
                }
            }
      });
      
    }
  });
  
  $(window).on("load resize", function () {
    //Mello set menu header to fixed position
      document.getElementById("shopify-section-header").classList.add("sticky");
      //Mello Fix Homepage slider pusher
       fixFeatureImage();
  }).resize();

})(jQuery);